import type {RefObject} from 'react';

/**
 * The `CloseIconProps` interface defines the properties for the CloseIcon component.
 */
interface CloseIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "close" — outlined, weight 300.
 * X icon for closing modals and dialogs.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const CloseIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'CloseIcon',
    width
}: CloseIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m480-438-198 198-42-42 198-198-198-198 42-42 198 198 198-198 42 42-198 198 198 198-42 42-198-198Z" />
    </svg>
);

CloseIcon.displayName = 'CloseIcon';